import { call, put, takeLatest } from "redux-saga/effects";
import {
  updateProStatusApi,
  proListApi,
  proProfile,
  profileListApi,
  deleteVideoListApi,
} from "../Api/api";
import {
  proListLoad,
  proListSuccess,
  proListFail,
  updateProStatusLoad,
  updateProStatusSuccess,
  updateProStatusFail,
  proProfileSuccess,
  proProfileFail,
  proProfileLoad,
  profileListSuccess,
  profileListFail,
  profileListLoad,
  videoDeleteSuccess,
  videoDeleteLoad,
  videoDeleteFailed,
} from "../slices/managePros.slice";
import { toast } from "react-toastify";

function* proListSaga(action) {
  try {
    const response = yield call(proListApi, action.payload);
    if (response.status === 0) {
      yield put(proListSuccess(response.result.data));
    } else {
      toast.error("Failed to load pros");
      yield put(proListFail());
    }
  } catch (e) {
    toast.error("Server error");
    yield put(proListFail());
  }
}

function* updateProStatusSaga(action) {
  try {
    const response = yield call(updateProStatusApi, action.payload.data);
    if (response.status === 0) {
      toast.success("Pro status updated successfully");
      yield put(updateProStatusSuccess());

      yield put(proListLoad(action.payload.payload));
    } else {
      toast.error("Failed to update pro status");
      yield put(updateProStatusFail());
    }
  } catch (e) {
    toast.error("Server error");
    yield put(updateProStatusFail());
  }
}
function* proProfileSaga(action) {
  try {
    const response = yield call(proProfile, action.payload);
    if (response.status === 0) {
      yield put(proProfileSuccess(response.result.data));
    } else {
      toast.error("Failed to fetch profile");
      yield put(proProfileFail());
    }
  } catch (error) {
    toast.error("Server error");
    yield put(proProfileFail());
  }
}

function* profileListSaga(action) {
  try {
    const response = yield call(profileListApi, action.payload);
    if (response.status === 0) {
      yield put(profileListSuccess(response.result.data));
    } else {
      toast.error("Failed to fetch profile list");
      yield put(profileListFail());
    }
  } catch (e) {
    toast.error("Server error");
    yield put(profileListFail());
  }
}

function* deleteVideoSaga(action) {
  try {
    const response = yield call(deleteVideoListApi, {
      post: action.payload.post,
    });
    if (response?.status == 0) {
      toast.success(response?.result?.message);
      yield call(action.payload.onSuccess);
      yield put(videoDeleteSuccess());
    } else {
      toast.error(response?.result?.message);
      yield put(videoDeleteFailed());
    }
  } catch (error) {
    toast.error("Some thing went wrong");
    yield put(videoDeleteFailed());
  }
}

export default function* manageProsSaga() {
  yield takeLatest(proListLoad.type, proListSaga);
  yield takeLatest(updateProStatusLoad.type, updateProStatusSaga);
  yield takeLatest(proProfileLoad.type, proProfileSaga);
  yield takeLatest(profileListLoad.type, profileListSaga);
  yield takeLatest(videoDeleteLoad.type, deleteVideoSaga);
}
